"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var selling_point_1 = __importDefault(require("~/components/estimate_banners/selling_point"));
var Form = function (props) {
    return (React.createElement("form", { action: props.path, method: "get", className: "estimateEntryBanner-InnerForm_EntryForm", "data-analytics-track-event": props.analyticsData, "data-user-insight-track-event-click": props.userInsightEventData },
        props.blogId && (React.createElement("input", { type: "hidden", name: "blog_id", value: props.blogId })),
        props.importCategoryGroupId && (React.createElement("input", { type: "hidden", name: "import_category_group_id", value: props.importCategoryGroupId })),
        React.createElement(ImportCategorySelector, { importCategoryId: props.importCategoryId, importCategoryOptions: props.importCategoryOptions }),
        React.createElement("div", { className: "estimateEntryBanner-InnerForm_InputContainer" },
            React.createElement("label", { htmlFor: "estimate_banners_inner_form_item_name", className: "estimateEntryBanner-InnerForm_Label" }, "\u5546\u54C1\u540D"),
            React.createElement("input", { type: "text", id: "estimate_banners_inner_form_item_name", name: "items[][name]", defaultValue: props.itemName || '', placeholder: "\u5546\u54C1\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", className: "estimateEntryBanner-InnerForm_Input" })),
        React.createElement(ConditionSelector, { itemCondition: props.itemCondition, itemConditionOptions: props.itemConditionOptions }),
        React.createElement("div", { className: "estimateEntryBanner-InnerForm_EntryBtnContainer" },
            React.createElement("button", { type: "submit", className: "estimateEntryBanner-InnerForm_EntryBtn" }, "\u8CB7\u53D6\u4FA1\u683C\u3092\u8ABF\u3079\u308B"),
            React.createElement("span", { className: "estimateEntryBanner-InnerForm_Arrow jirafficon jirafficon-arrow-right" })),
        React.createElement("div", { className: "estimateEntryBanner-InnerForm_FreeLabel " }, "\u304B\u3093\u305F\u30931\u5206\uFF01"),
        React.createElement(selling_point_1.default, null)));
};
var ImportCategorySelector = function (props) {
    if (props.importCategoryOptions.length > 0) {
        return (React.createElement("div", { className: "estimateEntryBanner-InnerForm_InputContainer" },
            React.createElement("label", { htmlFor: "estimate_banners_inner_form_import_category_id", className: "estimateEntryBanner-InnerForm_Label" }, "\u5546\u54C1\u30AB\u30C6\u30B4\u30EA"),
            React.createElement("select", { name: "import_category_id", id: "estimate_banners_inner_form_import_category_id", className: "estimateEntryBanner-InnerForm_Input estimateEntryBanner-InnerForm_Input-select", required: true },
                React.createElement("option", { value: "", key: -1 }, "\u5546\u54C1\u30AB\u30C6\u30B4\u30EA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"),
                props.importCategoryOptions.map(function (_a, i) {
                    var name = _a[0], id = _a[1];
                    return React.createElement("option", { value: id, selected: id === props.importCategoryId, key: i }, name);
                }))));
    }
    else {
        return (React.createElement("input", { type: "hidden", name: "import_category_id", value: props.importCategoryId || '' }));
    }
};
var ConditionSelector = function (props) {
    if (props.itemConditionOptions.length > 0) {
        return (React.createElement("div", { className: "estimateEntryBanner-InnerForm_InputContainer" },
            React.createElement("label", { htmlFor: "estimate_banners_inner_form_condition", className: "estimateEntryBanner-InnerForm_Label" }, "\u5546\u54C1\u72B6\u614B"),
            React.createElement("select", { name: "items[][condition]", id: "estimate_banners_inner_form_condition", className: "estimateEntryBanner-InnerForm_Input estimateEntryBanner-InnerForm_Input-select" }, props.itemConditionOptions.map(function (_a, i) {
                var name = _a[0], value = _a[1];
                return React.createElement("option", { value: value, selected: value === props.itemCondition, key: i }, name);
            }))));
    }
    else {
        return (React.createElement("input", { type: "hidden", name: "items[][condition]", value: props.itemCondition || '' }));
    }
};
exports.default = Form;
